const TaxisActions = {
  /* Types */
  SET_INSURANCE_TAXI_SELECTED: "SET_INSURANCE_TAXI_SELECTED",
  SET_TAXI_FORM_COMPLETED: "SET_TAXI_FORM_COMPLETED",
  SET_TAXI_QUOTE_COMPLETED: "SET_QUOTE_COMPLETED",
  SHOW_SPIN_TAXIS_FORM: "SHOW_SPIN_TAXIS_FORM",

  /* functions */
  setInsuranceTaxiSelected: (insurance_taxi_selected) => {
    return (dispatch) => {
      dispatch({
        type: TaxisActions.SET_INSURANCE_TAXI_SELECTED,
        insurance_taxi_selected,
      });
    };
  },
  setTaxiFormCompleted: (completed) => {
    return (dispatch) => {
      dispatch({
        type: TaxisActions.SET_TAXI_FORM_COMPLETED,
        completed
      })
    }
  },
  setTaxiQuoteCompleted: (completed) => {
    return (dispatch) => {
      dispatch({
        type: TaxisActions.SET_TAXI_QUOTE_COMPLETED,
        completed
      })
    }
  },
  setShowSpinTaxisForm: (show_spin_taxis_form) => {
    return (dispatch) => {
      dispatch({
        type: TaxisActions.SHOW_SPIN_TAXIS_FORM,
        show_spin_taxis_form
      })
    }
  }
};

export default TaxisActions;
